import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { CONTACT } from "@/lib/assets";
import { scrollToId } from "@/lib/api";

const INFO = [
  { icon: Phone, label: "Téléphone", value: CONTACT.phone, href: CONTACT.phoneHref, testid: "footer-phone" },
  { icon: Mail, label: "Courriel", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "footer-email" },
  { icon: MapPin, label: "Région", value: CONTACT.region, testid: "footer-region" },
  { icon: Clock, label: "Disponibilité", value: CONTACT.hours, testid: "footer-hours" },
];

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer-section" className="bg-anthracite border-t border-white/10">
      <div className="container-x py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Chapter number="10" label="Nous joindre" />
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
                Parlons de votre
                <br />
                <span className="gold-text">prochain véhicule.</span>
              </h2>
              <p className="mt-7 text-sm sm:text-base text-slate-400 font-light leading-relaxed max-w-md">
                Un conseiller dédié vous répond personnellement — sans pression, sans détour.
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <ul className="mt-10 space-y-5" data-testid="footer-contact-info">
                {INFO.map((item) => (
                  <li key={item.label} className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-gold shrink-0">
                      <item.icon size={16} strokeWidth={1.5} />
                    </span>
                    <div>
                      <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1">{item.label}</p>
                      {item.href ? (
                        <a data-testid={item.testid} href={item.href} className="text-sm text-slate-200 hover:text-gold-light transition-colors">
                          {item.value}
                        </a>
                      ) : (
                        <p data-testid={item.testid} className="text-sm text-slate-200">{item.value}</p>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="card-lux !p-8 sm:!p-10">
                <LeadForm type="conseiller" testid="form-contact" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.07]">
        <div className="container-x py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500 font-light text-center sm:text-left">
            © {new Date().getFullYear()} Gestion Automobile Exécutive Inc. — Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <button
              data-testid="footer-link-top"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-gold-light transition-colors"
            >
              Retour en haut
            </button>
            <a
              data-testid="footer-link-admin"
              href="/admin"
              className="text-[11px] uppercase tracking-[0.2em] text-slate-600 hover:text-slate-300 transition-colors"
            >
              Espace admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
